import * as React from "react";

const BlackFridayIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="263"
    height="62"
    viewBox="0 0 263 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_2001_380)">
      <rect y="20" width="252" height="36.1395" fill="black" />
    </g>
    <g filter="url(#filter1_d_2001_380)">
      <path
        d="M37.8832 37.3177C39.9218 38.0485 41.1863 39.6144 41.1863 41.8329C41.1863 44.9908 38.6057 46.8438 33.7544 46.8438H24V28.5746H33.2383C37.9864 28.5746 40.3089 30.532 40.3089 33.3507C40.3089 35.0993 39.4315 36.5087 37.8832 37.3177ZM32.5673 32.3068H29.0578V35.8301H32.5673C34.2705 35.8301 35.1478 35.2298 35.1478 34.0554C35.1478 32.907 34.2705 32.3068 32.5673 32.3068ZM33.3415 43.1117C35.0962 43.1117 36.0252 42.5114 36.0252 41.2587C36.0252 40.0059 35.0962 39.4057 33.3415 39.4057H29.0578V43.1117H33.3415Z"
        fill="#E5E5E5"
      />
      <path
        d="M43.8327 46.8438V28.5746H48.9421V42.7463H57.5611V46.8438H43.8327Z"
        fill="#E5E5E5"
      />
      <path
        d="M73.3065 46.8438L71.8872 43.2944H64.2488L62.8296 46.8438H57.6169L65.5907 28.5746H70.6227L78.6223 46.8438H73.3065ZM65.7455 39.484H70.3905L68.068 33.6378L65.7455 39.484Z"
        fill="#E5E5E5"
      />
      <path
        d="M88.8249 47.2092C83.0961 47.2092 78.8899 43.2683 78.8899 37.7092C78.8899 32.1502 83.0961 28.2092 88.8249 28.2092C92.1537 28.2092 94.8375 29.4359 96.5922 31.6543L93.3408 34.6296C92.2053 33.2463 90.8119 32.4894 89.0829 32.4894C86.1153 32.4894 84.0509 34.5774 84.0509 37.7092C84.0509 40.8411 86.1153 42.929 89.0829 42.929C90.8119 42.929 92.2053 42.1721 93.3408 40.7889L96.5922 43.7642C94.8375 45.9826 92.1537 47.2092 88.8249 47.2092Z"
        fill="#E5E5E5"
      />
      <path
        d="M110.999 46.8438L105.838 40.2147L103.928 42.2765V46.8438H98.8703V28.5746H103.928V36.1694L110.921 28.5746H116.547L109.167 36.6653L116.934 46.8438H110.999Z"
        fill="#E5E5E5"
      />
      <path
        d="M139.951 32.5677H130.894V36.587H138.868V40.5801H130.894V46.8438H126.021L126.5 28.5746H130.894L139.951 28.5746V32.5677Z"
        fill="#E5E5E5"
      />
      <path
        d="M153.515 46.8438L150.237 41.9894H147.45V46.8438H142.341V28.5746H150.599C155.527 28.5746 158.624 31.1584 158.624 35.3342C158.624 38.0224 157.334 40.0059 155.089 41.1021L158.985 46.8438H153.515ZM153.463 35.3342C153.463 33.6378 152.405 32.646 150.289 32.646H147.45V37.9963H150.289C152.405 37.9963 153.463 37.0046 153.463 35.3342Z"
        fill="#E5E5E5"
      />
      <path
        d="M161.443 46.8438V28.5746H166.552V46.8438H161.443Z"
        fill="#E5E5E5"
      />
      <path
        d="M170.187 46.8438V28.5746H178.729C184.716 28.5746 188.819 32.098 188.819 37.7092C188.819 43.3205 184.716 46.8438 178.729 46.8438H170.187ZM175.297 42.7202H178.523C181.593 42.7202 183.658 40.8672 183.658 37.7092C183.658 34.5513 181.593 32.6982 178.523 32.6982H175.297V42.7202Z"
        fill="#E5E5E5"
      />
      <path
        d="M204.777 46.8438L203.358 43.2944H195.719L194.3 46.8438H189.087L197.061 28.5746H202.093L210.093 46.8438H204.777ZM197.216 39.484H201.861L199.538 33.6378L197.216 39.484Z"
        fill="#E5E5E5"
      />
      <path
        d="M227 28.5746L220.084 40.293V46.8438H214.975V40.2147L208.085 28.5746H213.478L217.762 35.8301L222.045 28.5746H227Z"
        fill="#E5E5E5"
      />
    </g>
    <g filter="url(#filter2_d_2001_380)">
      <path
        d="M231.728 14.7124C232.348 15.3757 233.368 15.6037 234.257 15.278C235.53 14.8111 236.962 15.4914 237.261 16.7066C237.47 17.5553 238.256 18.1872 239.211 18.2731C240.578 18.3955 241.496 19.6014 241.138 20.8039C240.888 21.6441 241.26 22.5345 242.062 23.0124C243.209 23.697 243.404 25.1512 242.471 26.0654C241.819 26.704 241.692 27.6488 242.157 28.41C242.822 29.4993 242.249 30.8693 240.954 31.2852C240.05 31.576 239.453 32.3593 239.474 33.2292C239.504 34.4742 238.295 35.4454 236.935 35.2685C235.985 35.1443 235.055 35.5874 234.628 36.3664C234.016 37.4813 232.447 37.8316 231.335 37.102C230.557 36.5917 229.506 36.5917 228.729 37.102C227.616 37.8316 226.047 37.4813 225.435 36.3664C225.008 35.5874 224.078 35.1443 223.128 35.2685C221.769 35.4462 220.559 34.4742 220.589 33.2292C220.611 32.3593 220.013 31.576 219.109 31.2852C217.814 30.8693 217.241 29.4993 217.906 28.41C218.371 27.6488 218.244 26.7032 217.592 26.0654C216.659 25.152 216.854 23.697 218.001 23.0124C218.802 22.5345 219.176 21.6433 218.925 20.8039C218.567 19.6023 219.485 18.3964 220.852 18.2731C221.807 18.1872 222.593 17.5553 222.802 16.7066C223.101 15.4914 224.533 14.8102 225.806 15.278C226.695 15.6045 227.716 15.3766 228.336 14.7124C229.223 13.7625 230.839 13.7625 231.728 14.7124Z"
        fill="#155DFC"
      />
    </g>
    <path
      d="M225.032 29.4238C224.568 29.4238 224.139 29.3221 223.747 29.1187C223.359 28.9152 223.046 28.6445 222.807 28.3067C222.572 27.9652 222.455 27.5909 222.455 27.184L222.468 23.6473C222.468 23.2331 222.585 22.8607 222.82 22.5301C223.05 22.1959 223.361 21.9288 223.753 21.729C224.145 21.5256 224.572 21.4238 225.032 21.4238C225.51 21.4238 225.938 21.5237 226.318 21.7236C226.701 21.9234 227.008 22.1922 227.238 22.5301C227.473 22.8643 227.59 23.2367 227.59 23.6473L227.603 27.184C227.603 27.5909 227.488 27.9633 227.258 28.3012C227.023 28.6427 226.712 28.9152 226.324 29.1187C225.936 29.3221 225.505 29.4238 225.032 29.4238ZM225.032 28.0778C225.297 28.0778 225.527 27.987 225.723 27.8053C225.919 27.62 226.017 27.4129 226.017 27.184L226.004 23.6473C226.004 23.4002 225.913 23.1913 225.729 23.0206C225.546 22.8498 225.314 22.7644 225.032 22.7644C224.764 22.7644 224.533 22.848 224.342 23.0151C224.15 23.1822 224.054 23.3929 224.054 23.6473V27.184C224.054 27.4275 224.15 27.6382 224.342 27.8162C224.533 27.9906 224.764 28.0778 225.032 28.0778Z"
      fill="white"
    />
    <path
      d="M230.129 29.3148H228.658C228.615 29.3148 228.594 29.2967 228.594 29.2603L228.62 21.5928C228.62 21.5637 228.637 21.5492 228.671 21.5492H232.866C232.909 21.5492 232.93 21.5637 232.93 21.5928V22.8516C232.93 22.8807 232.913 22.8952 232.879 22.8952H230.193V24.6282H232.879C232.913 24.6282 232.93 24.6464 232.93 24.6827L232.943 25.947C232.943 25.9761 232.921 25.9906 232.879 25.9906H230.193V29.2603C230.193 29.2967 230.172 29.3148 230.129 29.3148Z"
      fill="white"
    />
    <path
      d="M235.641 29.3148H234.171C234.128 29.3148 234.107 29.2967 234.107 29.2603L234.132 21.5928C234.132 21.5637 234.149 21.5492 234.183 21.5492H238.378C238.421 21.5492 238.442 21.5637 238.442 21.5928V22.8516C238.442 22.8807 238.425 22.8952 238.391 22.8952H235.705V24.6282H238.391C238.425 24.6282 238.442 24.6464 238.442 24.6827L238.455 25.947C238.455 25.9761 238.434 25.9906 238.391 25.9906H235.705V29.2603C235.705 29.2967 235.684 29.3148 235.641 29.3148Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_i_2001_380"
        x="0"
        y="20"
        width="252"
        height="40.1396"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="6.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2001_380"
        />
      </filter>
      <filter
        id="filter1_d_2001_380"
        x="14"
        y="21.2092"
        width="223"
        height="39"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2001_380"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2001_380"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_2001_380"
        x="198"
        y="0"
        width="64.0625"
        height="61.4849"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="9.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2001_380"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2001_380"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default BlackFridayIcon;
